var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class Uploader {
  constructor(uploadFunc) {
    __publicField(this, "uploadFunc");
    this.uploadFunc = uploadFunc;
  }
  upload(file) {
    return new Promise((resolve, reject) => {
      this.uploadFunc(file, ({ data, error }) => {
        if (error) {
          reject(error);
        } else {
          resolve({ data });
        }
      });
    });
  }
}
export {
  Uploader
};
//# sourceMappingURL=Uploader.js.map
